import React from 'react';

export const LoadingContext = React.createContext({
    isLoading: false,
    openLoading: () => { console.log("openLoading default"); },
    closeLoading: () => { console.log("closeLoading default"); }
});
